export const CELLPHONE_SMALL_WIDTH = 360;
export const CELLPHONE_WIDTH = 536.5;
export const CELLPHONE_LARGE_WIDTH = 576.5;
export const TABLET_SMALLER_WIDTH = 600;
export const TABLET_SMALL_WIDTH = 768.5;
export const TABLET_MEDIUM = 915;
export const TABLET_WIDTH = 991.5;
export const COMPUTER_SMALL_WIDTH = 1199.5;
export const COMPUTER_MEDIUM_WIDTH = 1415;
